
/**
 * Module dependencies.
 */

import { MenuLink } from 'src/core/menu';
import { columnTitleStyles } from './footer-theme';
import { units } from 'src/styles/utils';
import FooterLinkList from './footer-link-list';
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode,
  className?: string,
  links?: MenuLink[],
  title: string
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(2)};
  min-width: 0;
`;

/**
 * `Title` styled component.
 *
 * A heading rather than a paragraph: it is what lets a screen reader jump
 * between the footer sections, which the previous footer also allowed.
 */

const Title = styled.h2`
  ${columnTitleStyles}
`;

/**
 * `FooterColumn` component.
 *
 * A footer column heading with either a list of links or free content, used by
 * the desktop layout and by the mobile accordion panels.
 */

const FooterColumn = (props: Props): ReactElement => {
  const { children, className, links, title } = props;

  return (
    <Wrapper className={className}>
      <Title>
        {title}
      </Title>

      {links && (
        <FooterLinkList links={links} />
      )}

      {children}
    </Wrapper>
  );
};

/**
 * Export `FooterColumn` component.
 */

export default FooterColumn;
